import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { trackPageView } from '@snowplow/browser-tracker'

import { useAuth } from '@/contexts/AuthContext'

import { PAGE_PATHS } from '@/services/paths'
import { getUnityUA, persistUnityUAFromURL } from '@/services/unityUA'

interface PublicProps {
  children: React.ReactNode
  unityAgent?: string
}

const Public = ({ children, unityAgent }: PublicProps) => {
  const router = useRouter()
  const { loadingUser, signed, embedded } = useAuth()

  useEffect(() => {
    trackPageView({ title: router.asPath })
  }, [router.asPath])

  useEffect(() => {
    persistUnityUAFromURL()
  }, [])

  useEffect(() => {
    if (loadingUser) return

    if (signed) {
      if (String(embedded) === 'true') {
        const ua = unityAgent || getUnityUA()
        const query = ua ? `?x-unity-user-agent=${encodeURIComponent(ua)}` : ''

        router.replace(`${PAGE_PATHS.embedded}${query}`)
      } else {
        router.replace(PAGE_PATHS.home)
      }
    } else {
      // Comportamentos padrão para páginas públicas
    }
  }, [loadingUser, signed, unityAgent, embedded, router])

  return !loadingUser && !signed && children
}

export default Public
